/* eslint-disable react/prop-types */
import MoreInfosComponent from "./more-infos";
import { useState } from "react";

function MoreInfos({ announcement, updateAnnouncement }) {
  const [isInfoValid, setInfoValid] = useState(announcement.info);

  const [isFacilitationValid, setFacilitationValid] = useState(
    announcement.facilitation
  );
  const [isInterventionsValid, setIntervetionsValid] = useState(
    announcement.interventions
  );

  const [isCumulationValid, setCumulationValid] = useState(
    announcement.cumulation
  );

  const handleInterventionsChange = (e) => {
    updateAnnouncement("interventions", e.target.value, announcement);

    if (e.target.value) {
      setIntervetionsValid(true);
    } else {
      setIntervetionsValid(false);
    }
  };

  const handleFacilitationChange = (e) => {
    updateAnnouncement("facilitation", e.target.value, announcement);

    if (e.target.value) {
      setFacilitationValid(true);
    } else {
      setFacilitationValid(false);
    }
  };

  const handleInfoChange = (e) => {
    updateAnnouncement("info", e.target.value, announcement);

    if (e.target.value) {
      setInfoValid(true);
    } else {
      setInfoValid(false);
    }
  };

  const handleCumulationChange = (e) => {
    updateAnnouncement("cumulation", e.target.value, announcement);

    if (e.target.value) {
      setCumulationValid(true);
    } else {
      setCumulationValid(false);
    }
  };

  return (
    <MoreInfosComponent
      onInterventionsChange={handleInterventionsChange}
      onFacilitationChange={handleFacilitationChange}
      isFacilitationValid={isFacilitationValid}
      isInterventionsValid={isInterventionsValid}
      onInfoChange={handleInfoChange}
      isInfoValid={isInfoValid}
      onCumulationChange={handleCumulationChange}
      isCumulationValid={isCumulationValid}
      announcement={announcement}
    />
  );
}

export default MoreInfos;
